import { EnterpriseStatus, Industry } from 'types/models/enterprise';

export const INDUSTRY_LABELS: Record<Industry, string> = {
  [Industry.AGRICULTURE]: 'Agriculture',
  [Industry.MINING]: 'Mining'
};

export const ENTERPRISE_STATUS_LABELS: Record<EnterpriseStatus, string> = {
  [EnterpriseStatus.ACTIVE]: 'Active',
  [EnterpriseStatus.DEMO]: 'Demo',
  [EnterpriseStatus.DISABLED]: 'Disabled',
  [EnterpriseStatus.DUPLICATE]: 'Duplicate',
  [EnterpriseStatus.PAST_DUE]: 'Past due',
  [EnterpriseStatus.TEST]: 'Test',
  [EnterpriseStatus.TRIAL]: 'Trial',
  [EnterpriseStatus.TRIAL_EXPIRED]: 'Trial expired'
};

export const ENTERPRISE_NOT_FOUND_MESSAGE = 'Enterprise not found';